package top.wcpe.allincore.ui.runtime.element

/**
 * 渲染变换参数：封装平移、缩放、旋转、倾斜、透视与透明度。
 *
 * 所有 setter 返回 this 以支持流式调用（保留原 Java 公开 fluent ABI）。
 */
open class RenderTransform {

    private var translateXValue: Float = 0f
    private var translateYValue: Float = 0f
    private var scaleXValue: Float = DEFAULT_SCALE
    private var scaleYValue: Float = DEFAULT_SCALE
    private var opacityValue: Float = DEFAULT_OPACITY
    private var rotationValue: Float = 0f
    private var rotateXValue: Float = 0f
    private var rotateYValue: Float = 0f
    private var skewXValue: Float = 0f
    private var skewYValue: Float = 0f
    private var perspectiveValue: Float = DEFAULT_PERSPECTIVE

    // 变换原点：归一化比例，0=左/上、0.5=盒中心、1=右/下；默认 0.5 等于历史硬编码盒中心
    private var originXValue: Float = DEFAULT_ORIGIN
    private var originYValue: Float = DEFAULT_ORIGIN

    fun getTranslateX(): Float = translateXValue

    fun setTranslateX(value: Float): RenderTransform {
        translateXValue = value
        return this
    }

    fun getTranslateY(): Float = translateYValue

    fun setTranslateY(value: Float): RenderTransform {
        translateYValue = value
        return this
    }

    fun getScaleX(): Float = scaleXValue

    fun setScaleX(value: Float): RenderTransform {
        scaleXValue = value
        return this
    }

    fun getScaleY(): Float = scaleYValue

    fun setScaleY(value: Float): RenderTransform {
        scaleYValue = value
        return this
    }

    fun getOpacity(): Float = opacityValue

    fun setOpacity(value: Float): RenderTransform {
        opacityValue = value
        return this
    }

    fun getRotation(): Float = rotationValue

    fun setRotation(value: Float): RenderTransform {
        rotationValue = value
        return this
    }

    fun getRotateX(): Float = rotateXValue

    fun setRotateX(value: Float): RenderTransform {
        rotateXValue = value
        return this
    }

    fun getRotateY(): Float = rotateYValue

    fun setRotateY(value: Float): RenderTransform {
        rotateYValue = value
        return this
    }

    fun getSkewX(): Float = skewXValue

    fun setSkewX(value: Float): RenderTransform {
        skewXValue = value
        return this
    }

    fun getSkewY(): Float = skewYValue

    fun setSkewY(value: Float): RenderTransform {
        skewYValue = value
        return this
    }

    fun getPerspective(): Float = perspectiveValue

    fun setPerspective(value: Float): RenderTransform {
        perspectiveValue = value
        return this
    }

    fun getOriginX(): Float = originXValue

    fun setOriginX(value: Float): RenderTransform {
        originXValue = value
        return this
    }

    fun getOriginY(): Float = originYValue

    fun setOriginY(value: Float): RenderTransform {
        originYValue = value
        return this
    }

    companion object {
        /** perspective 默认值：1000 像素视距，表示无明显透视效果。 */
        const val DEFAULT_PERSPECTIVE = 1000f

        /** 缩放默认值（1=原始大小）。 */
        private const val DEFAULT_SCALE = 1f

        /** 不透明度默认值（1=完全不透明）。 */
        private const val DEFAULT_OPACITY = 1f

        /** 变换原点默认值（0.5=盒中心）。 */
        private const val DEFAULT_ORIGIN = 0.5f
    }
}
